import { createInstance } from '@optimizely/react-sdk';
import { ensureConfig, getConfig } from '@edx/frontend-platform';

ensureConfig([
  'OPTIMIZELY_FULL_STACK_SDK_KEY',
], 'Frontend Plugin Advertisements Optimizely module');

const DEFAULT_OPTIMIZELY_AGENT_CONFIG = {
  eventFlushInterval: 1000,
  eventBatchSize: 10,
};

/**
 * Initializing the Optimizely instance at the top-level will not work, becaused it may be initialized before
 * the OPTIMIZELY_FULL_STACK_SDK_KEY is available and will not be reinitialized afterward. Wrapping the initialization
 * in a function allows components to request the instance as-needed.
 */
let instance = null;
const getOptimizely = () => {
  const OPTIMIZELY_SDK_KEY = getConfig().OPTIMIZELY_FULL_STACK_SDK_KEY;
  const OPTIMIZELY_AGENT_CONFIG = getConfig().OPTIMIZELY_AGENT_CONFIG || {};

  if (!instance && OPTIMIZELY_SDK_KEY) {
    instance = createInstance({
      sdkKey: OPTIMIZELY_SDK_KEY,
      ...{
        ...DEFAULT_OPTIMIZELY_AGENT_CONFIG,
        ...OPTIMIZELY_AGENT_CONFIG,
      },
    });
  }

  return instance;
};

const OPTIMIZELY_VTR_COPY_CHANGE_EXPERIMENT_KEY = 'verified_take_rate_preview_watermark_experimentation';

const OPTIMIZELY_VTR_COPY_CHANGE_EXPERIMENT_VARIATION_KEYS = {
  CERTIFICATE_PREVIEW: 'certificate_preview',
  CERTIFICATE_PREVIEW_WITH_COPY: 'certificate_preview_with_copy',
  CONTROL: 'control',
  OFF: 'off',
};

const OPTIMIZELY_VTR_BULLET_EXPERIMENT = {
  KEY: 'cta_bullet_points_experiment',
  ANY_CLICK_ACTION: 'upgrade_button_click',
  MODAL_CLICK_ACTION: 'modal_upgrade_button_click',
  SIDEBAR_CLICK_ACTION: 'sidebar_upgrade_button_click',
  VARIATIONS: {
    OFF: 'off',
    CONTROL: 'control',
    EXPERIMENT: 'new_experience',
  },
};

const OPTIMIZELY_EVENT_KEYS = {
  UPGRADE_BUTTON_CLICK: 'upgrade_button_click',
  DECLINE_UPGRADE_BUTTON_CLICK: 'decline_upgrade_button_click',
};

const OPTIMIZELY_AUDIT_TRIAL_EXPERIMENT = {
  KEY: 'xpert_audit_trial_experiment',
  ANY_CLICK_ACTION: 'upgrade_button_click',
  VARIATIONS: {
    OFF: 'off',
    CONTROL: 'control',
    XPERT_AUDIT_14_DAY_TRIAL: 'xpert_audit_14_day_trial',
    XPERT_AUDIT_28_DAY_TRIAL: 'xpert_audit_28_day_trial',
  },
};

export {
  getOptimizely,
  OPTIMIZELY_EVENT_KEYS,
  OPTIMIZELY_VTR_COPY_CHANGE_EXPERIMENT_KEY,
  OPTIMIZELY_VTR_COPY_CHANGE_EXPERIMENT_VARIATION_KEYS,
  OPTIMIZELY_VTR_BULLET_EXPERIMENT,
  OPTIMIZELY_AUDIT_TRIAL_EXPERIMENT,
};
